import { render, staticRenderFns } from "./CancelableText.vue?vue&type=template&id=656daf78&functional=true"
import script from "./CancelableText.vue?vue&type=script&lang=js"
export * from "./CancelableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports